import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { WarehouseService } from '../../../_services/warehouse.service';

@Component({
  selector: 'app-delete-warehouse',
  templateUrl: './delete-warehouse.component.html',
  styleUrls: ['./delete-warehouse.component.css']
})
export class DeleteWarehouseComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private to_delete;

  constructor(private service: WarehouseService) { }

  ngOnInit() {
  }

  openModal(warehouse_id){
    this.to_delete = warehouse_id;
    jQuery('#delete-warehouse-modal').modal({closable: false}).modal('show');
  }

  deleteWarehouse(){
    if(!this.to_delete) { // Return false if the ID of the contact is not stored
      jQuery('#delete-warehouse-modal').modal('hide');
      return false;
    } 
    let warehouse_id = this.to_delete // Store it in a var
    this.to_delete = undefined; // Invalidate the contact to delete (avoid spamming during the deletion process)
    jQuery('#delete-warehouse-modal').modal({closable: false}); // Set the modal unclosable during the deletion process
    this.service.deleteWarehouse(warehouse_id) // Delete the Contact
      .subscribe(response => {
        jQuery('#delete-warehouse-modal').modal('hide');
        this.refresh.emit(true); // Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/warehouse/delete-warehouse/delete-warehouse.component.ts